import {
  CREATE_SUCCESS,
  CREATE_FAIL,
  UPLOAD_FILE_SUCCESS,
  UPLOAD_FILE_FAIL,
  SEARCH_SUCCESS,
  SEARCH_FAIL,
  UPDATE_SUCCESS,
  UPDATE_FAIL,
  ACCOUNT_STOP_SUCCESS,
  ACCOUNT_STOP_FAIL,
  STUDENT_MENU_INIT_SUCCESS,
  STUDENT_MENU_INIT_FAIL,
  SELFEVALUATION_CHECK_OK,
  SELFEVALUATION_CHECK_NG,
  SELFEVALUATION_CHECK_FAIL,
  EXCEL_DOWNLOAD
} from "../actions/student";

const initialState = {
  rows: [],
  list: [],
  term: [],
  student: null
};

const student = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case CREATE_SUCCESS:
      return {
        ...state,
        messageCode: payload.messageCode,
        message: payload.message
      };
    case CREATE_FAIL:
      return {
        ...state,
        messageCode: payload.messageCode,
        message: payload.message,
        error: payload.error
      };
    case UPLOAD_FILE_SUCCESS:
      return {
        ...state,
        messageCode: payload.messageCode,
        message: payload.message
      };
    case UPLOAD_FILE_FAIL:
      return {
        ...state,
        error: payload.error,
        messageCode: payload.messageCode,
        message: payload.message
      };
    case SEARCH_SUCCESS:
      return {
        ...state,
        rows: payload.rows
      };
    case SEARCH_FAIL:
      return {
        ...state,
        error: payload.error
      };
    case UPDATE_SUCCESS:
      return {
        ...state
      };
    case UPDATE_FAIL:
      return {
        ...state,
        error: payload.error
      };
    case ACCOUNT_STOP_SUCCESS:
      return {
        ...state
      };
    case ACCOUNT_STOP_FAIL:
      return {
        ...state,
        error: payload.error
      };
    case STUDENT_MENU_INIT_SUCCESS:
      return {
        ...state,
        list: payload.list,
        term: payload.term,
        student: payload.student
      };
    case STUDENT_MENU_INIT_FAIL:
      return {
        ...state,
        error: payload.error,
        messageCode: payload.messageCode,
        message: payload.message
      };
    case SELFEVALUATION_CHECK_OK:
      return {
        ...state
      };
    case SELFEVALUATION_CHECK_NG:
      return {
        ...state,
        messageCode: payload.messageCode,
        message: payload.message
      };

    case SELFEVALUATION_CHECK_FAIL:
      return {
        ...state,
        error: payload.error
      };
    case EXCEL_DOWNLOAD:
      return {
        ...state,
        url: payload.url
      };
    default:
      return {
        ...state
      };
  }
};

export default student;
